export default __webpack_public_path__ + "static/media/148439.201e5b1d.jpg";